"use client";

import { useCallback, useRef } from "react";
import * as styles from "./SeeInActionPanel.module.scss";

export interface SeeInActionPanelProps {
	videoUrl: string;
	posterUrl?: string;
	ariaLabel?: string;
	/**
	 * Fired the first time the video starts playing — once per mount, so
	 * pause/resume doesn't re-fire. Used for video_click analytics.
	 */
	onPlay?: () => void;
}

export function SeeInActionPanel({
	videoUrl,
	posterUrl,
	ariaLabel,
	onPlay
}: SeeInActionPanelProps) {
	const playFiredRef = useRef(false);

	const handlePlay = useCallback(() => {
		if (playFiredRef.current) return;
		playFiredRef.current = true;
		onPlay?.();
	}, [onPlay]);

	return (
		<div className={styles["panel"]} data-component="SeeInActionPanel">
			<video
				className={styles["video"]}
				controls
				playsInline
				preload="metadata"
				src={videoUrl}
				poster={posterUrl}
				aria-label={ariaLabel}
				onPlay={handlePlay}
			/>
		</div>
	);
}
